import { HeadPositionEntity, LegalClientBodyEntity } from 'api/types/entity';
import { yesOrNotOption } from 'helpers';
import { TFunc } from 'libs/i18n';
import {
  LegalClientHeadPositionFormType,
  LegalClientHeadType,
} from 'modules/client/common/forms/legalClientHeadPositionForm';

export const parseHeadPositionInitialValue = (
  client: {
    hasLegalClientBody?: boolean;
    legalClientBodies?: LegalClientBodyEntity[];
    isFirstHead?: boolean;
    position?: HeadPositionEntity;
  },
  t: TFunc
): LegalClientHeadPositionFormType['position'] => ({
  bodies: !client.hasLegalClientBody
    ? [
        {
          value: '-1',
          label: t(
            'client.legal.legalClientHead.position.body.notBelongOrgans'
          ),
        },
      ]
    : client.legalClientBodies?.map((body) => ({
        value: body.id!,
        label: body.name,
      })),
  firstHead: yesOrNotOption(t, client.isFirstHead ?? false),
  headType: {
    label: t(`client.legal.legalClientHead.position.headType.person`),
    value: LegalClientHeadType.person,
  },
  dateOfExpiration: client.position?.expirationDate,
  positionConfirmationFiles: client.position?.files ?? [],
  position: client.position?.position ?? '',
});
